export { default } from './WidgetBoxWideWrapper';
